// extracted by mini-css-extract-plugin
module.exports = {"setting-icon":"CrmSettings_setting-icon__1iNtR","setting-icon--active":"CrmSettings_setting-icon--active__39F7b"};